const STORAGE_KEY = "inhome-sidebar-collapsed";

function isDesktop() {
  return typeof window !== "undefined" && window.innerWidth >= 768;
}

export function isSidebarCollapsed() {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

export function applySidebarCollapsed(collapsed) {
  if (typeof document === "undefined" || !isDesktop()) {
    return;
  }

  document.body.classList.toggle("sidebar-collapse", collapsed);
}

export function setSidebarCollapsed(collapsed) {
  try {
    localStorage.setItem(STORAGE_KEY, collapsed ? "true" : "false");
  } catch {
    // ignore storage errors
  }

  applySidebarCollapsed(collapsed);
}

export function initSidebarState() {
  if (!isDesktop()) {
    return;
  }

  applySidebarCollapsed(isSidebarCollapsed());
}

export function toggleSidebarCollapsed() {
  const collapsed = !document.body.classList.contains("sidebar-collapse");
  setSidebarCollapsed(collapsed);
  return collapsed;
}

export function closeMobileSidebar() {
  if (typeof document === "undefined") {
    return;
  }

  document.body.classList.remove("sidebar-open");
}
